module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "Hamid Peseschkian.eaf4969a.jpg" + "?" + Date.now();